var e, r;
function i() {
  if (r) return e;
  r = 1;
  function a() {
    this.__data__ = [], this.size = 0;
  }
  return e = a, e;
}
export {
  i as __require
};
